const dataSlider = [
  {
    id: 0,
    name: "Tracy Thomas",
    review: "The Code School changed my life!",
    image: "/images/tracythomas.jpg",
  },
  {
    id: 1,
    name: "Norman Lawson",
    review: "I learned so much at The Code School!",
    image: "/images/normanlawson.jpg",
  },
  {
    id: 2,
    name: "Randall Payne",
    review: "This was a great experience!",
    image: "/images/randallpayne.jpg",
  },
  {
    id: 3,
    name: "Craig Kim",
    review: "I went from zero experience to developer!",
    image: "/images/craigkim.jpg",
  },
  {
    id: 4,
    name: "Amelia Thomas",
    review: "I gained all of the skills I needed!",
    image: "/images/ameliathomas.jpg",
  },
];

export default dataSlider;
